<script>
export default {
  name: 'mixin-constant',
  created() {
    this.ConstData = (typeof ConstData === 'object') ? ConstData : {};
  },
  data() {
    return { ConstData: {} };
  },
};
</script>



// WEBPACK FOOTER //
// src/mixins/mixin-constant.vue